import React from 'react';
import { useParams } from 'react-router-dom';

const SubSubcategoryPage = () => {
  const { categorySlug, subcategorySlug, subSubcategorySlug } = useParams();
  return <div />;
};

export default SubSubcategoryPage;